import {
  FETCH_POSITION_FAIL,
  FETCH_POSITION_REQUEST,
  FETCH_POSITION_SUCCESS,
} from "../../ActionType/BranchType/PositionType";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const getPositionAction = () => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: FETCH_POSITION_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("position", config);
    const { status, data } = response;
    
    if (status == 200) {
      dispatch({
        type: FETCH_POSITION_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_POSITION_FAIL,
      payload: [],
    });
  }
};
